import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { hasBusinessPermission } from '../../../helpers/permissions';

const BranchMenuItems = ({ iconOnly, chainId, match, location }) => {
    const pathname = `/chain/${chainId}`;

    function renderDetailsMenuItem() {
        const title = i18next.t('navDetailsTitle');
        const active = location.pathname === pathname;

        return (
            <Menu.Item key="details" as={Link} active={active} to={pathname} name={title}>
                <Icon name='info circle' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderCatalogMenuItem() {
        if (!hasBusinessPermission('menu')) return null;

        const title = i18next.t('navMenuTitle');
        const active = location.pathname.startsWith(pathname + '/menu-editor');

        return (
            <Menu.Item key="menu" as={Link} active={active} to={pathname + '/menu-editor'}>
                <Icon name='book' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderWebsiteMenuItem() {
        const title = i18next.t('navWebsiteTitle');
        const active = location.pathname.startsWith(pathname + '/website');

        return (
            <Menu.Item key="website" as={Link} active={active} to={pathname + '/website'}>
                <Icon name='internet explorer' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderMarketingMenuItem() {
        if (!hasBusinessPermission('marketing')) return null;

        const title = i18next.t('navMarketingToolTitle');
        const active = location.pathname.startsWith(pathname + '/marketing');

        return (
            <Menu.Item key="marketing" as={Link} active={active} to={pathname + '/marketing'}>
                <Icon name='paint brush' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderLocalesMenuItem() {
        if (!hasBusinessPermission('marketing')) return null;

        const title = i18next.t('localesTitle');
        const active = location.pathname.startsWith(pathname + '/locales');

        return (
            <Menu.Item key="locales" as={Link} active={active} to={pathname + '/locales'}>
                <Icon name='translate' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    return (
        <Fragment>
            {renderDetailsMenuItem()}
            {renderCatalogMenuItem()}
            {renderWebsiteMenuItem()}
            {renderMarketingMenuItem()}
            {renderLocalesMenuItem()}
        </Fragment>
    );
};

BranchMenuItems.propTypes = {
    chainId: PropTypes.string,
    
    match: PropTypes.any,
    location: PropTypes.any,
    iconOnly: PropTypes.bool,
};

export default BranchMenuItems;
